/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useRecoilValue } from 'recoil';
import { projectsDataAtom } from '../Atoms';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: 0,
    paddingLeft: 0,
  },
  dot: {
    width: '16px',
    height: '16px',
    borderRadius: '50px',
    margin: '8px',
  },
});

const ComplexityStack = function ComplexityStack({ projectName }) {
  const classes = useStyles();
  const intl = useIntl();
  const projectsData = useRecoilValue(projectsDataAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);

  useEffect(() => {
    setCurrentProjectData(projectsData.find((x) => x.Name === projectName && x.isCurrent === 1));
  }, [projectsData]);

  let complexity = (currentProjectData?.iComplessita + currentProjectData?.eComplessita) / 2;

  useEffect(() => {
    complexity = (currentProjectData?.iComplessita + currentProjectData?.eComplessita) / 2;
  }, [currentProjectData]);

  /**check the complexity value to return an indicator of complexity **/
  if (complexity > 6) {
    return (
      <Container className={classes.row}>
        <div className={classes.dot} style={{ backgroundColor: '#D0021B' }} />
        <Typography variant="subtitle1">
          <b>{intl.messages.HIGH}</b>
        </Typography>
      </Container>
    );
  }
  if (complexity < 4) {
    return (
      <Container className={classes.row}>
        <div className={classes.dot} style={{ backgroundColor: '#8BDB2D' }} />
        <Typography variant="subtitle1">
          <b>{intl.messages.LOW}</b>
        </Typography>
      </Container>
    );
  }
  return (
    <Container className={classes.row}>
      <div className={classes.dot} style={{ backgroundColor: '#F5A623' }} />
      <Typography variant="subtitle1">
        <b>{intl.messages.MEDIUM}</b>
      </Typography>
    </Container>
  );
  /****/
};

export default ComplexityStack;
